var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.accessPassword || _vm.passwordValidated || _vm.isPreview ? _c(_vm.renderer, {
    tag: "component"
  }) : _c('FormSubmitAccessPassword', {
    attrs: {
      "accessPassword": _vm.accessPassword
    },
    on: {
      "validate-password": _vm.validatePassword
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }